import { createContext } from "react";

const TextContext = createContext();

export default TextContext;
